import React from "react";
import { Trash2 } from "lucide-react";
import { getAllProductsIMG } from "../../services/api";
import {NavLink} from "react-router-dom"

export default function CartItemCard({ item, onIncrease, onDecrease, onDelete }) {
    return (
          <div className="flex items-center justify-between border-b border-gray-300 rounded-lg bg-gray-100 p-3 h-[105px]">
            <div className="flex items-center gap-4">
                <div className="w-[80px] h-[80px] rounded-[12px] overflow-hidden bg-blue-100">
                    <img
                        src={`${getAllProductsIMG}${item.image}`}
                        alt={item.name}
                        className="w-full h-full p-1 object-contain"
                    />
                </div>

                <div className="max-w-[220px]">
                    <h3 className="text-[12px] font-medium leading-tight text-gray-700">
                        {item.name.split(" ").slice(0, 6).join(" ")}
                        {item.name.split(" ").length > 6 && "..."}
                    </h3>

                    <p className="text-gray-500 text-[11px] mt-1">
                        {item.size} ml
                    </p>

                    <div className="flex items-center gap-3 mt-2">
                        <button
                            onClick={onDelete}
                            className="bg-gray-100 text-gray-500 border border-gray-300 rounded-lg px-[7px] h-[1.6rem] cursor-pointer hover:border-gray-400 transition"
                        >
                            <Trash2 size={13} />
                        </button>

                        <div className="flex items-center justify-between border border-gray-300 bg-white rounded-lg w-[4.3rem] h-[1.6rem] overflow-hidden">
                            <button
                                onClick={onDecrease}
                                className="font-medium text-[20px] px-2 h-full cursor-pointer text-gray-400 hover:bg-gray-100 transition rounded-lg"
                            >
                                −
                            </button>
                            <span className="text-[13px] text-gray-700">
                                {item.qty || 1}
                            </span>
                            <button
                                onClick={onIncrease}
                                className="text-[19px] px-2 h-full cursor-pointer text-gray-400 hover:bg-gray-100 transition rounded-lg"
                            >
                                +
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-right">
                <h4 className="text-[14px] font-base">₹{item.price}</h4>
                <p className="text-gray-500 line-through text-[12px] mt-1 font-light">₹{item.mrp}</p>
            </div>
        </div>
    );
}